import AbstractFetch from '~/repositories/AbstractFetch';
import type { IFetchOptions, IRequestOptions, IResponse } from '~/types/repositories';

export default class DefaultFetch extends AbstractFetch {
  constructor(fetchOptions: IFetchOptions) {
    super(fetchOptions.baseURL, fetchOptions.fetch);
  }

  async get<T>(url: string, options?: any): Promise<IResponse<T>> {
    return this.fetch<IResponse<T>>(url, { ...options, method: 'GET' });
  }

  async fetchData<T>(url: string, options?: IRequestOptions): Promise<IResponse<T>> {
    return this.fetch<IResponse<T>>(url, options);
  }
}
